import i18next from 'i18next';
import EN from '$js/i18n/en/index';

// Todo: Make languages more dynamic
export class TranslationService {
  constructor() {
    void i18next.init({
      lng: 'en',
      fallbackLng: 'en',
      debug: document.documentElement.dataset.build === 'dev',
      resources: {
        en: {
          translation: EN,
        },
      },
    });
  }

  translate(value: string, options?: Record<string, string | number>): string {
    return i18next.t(value, options);
  }
}
